import React, { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, db } from '../firebase';
import { doc, getDoc, collection, getDocs } from 'firebase/firestore';

function Profile() {
  const [user] = useAuthState(auth);
  const [userInfo, setUserInfo] = useState(null);
  const [lectures, setLectures] = useState([]);
  const [quizStats, setQuizStats] = useState({ score: 0, total: 0 });

  useEffect(() => {
    const fetchUserInfo = async () => {
      if (user) {
        const docRef = doc(db, 'users', user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setUserInfo(docSnap.data());
        }
      }
    };

    const fetchLectures = async () => {
      const snap = await getDocs(collection(db, 'lectures'));
      const data = snap.docs.map(doc => doc.data());
      setLectures(data);
    };

    const fetchQuizStats = async () => {
      if (user) {
        const snap = await getDocs(collection(db, 'users', user.uid, 'quizzes'));
        let total = 0;
        let score = 0;
        snap.forEach(doc => {
          const data = doc.data();
          score += data.score;
          total += data.total;
        });
        setQuizStats({ score, total });
      }
    };

    fetchUserInfo();
    fetchLectures();
    fetchQuizStats();
  }, [user]);

  if (!user) {
    return <div className="container mt-5">الرجاء تسجيل الدخول لعرض الملف الشخصي.</div>;
  }

  const progress =
    userInfo &&
    typeof userInfo.completedLectures === 'number' &&
    typeof userInfo.totalLectures === 'number' &&
    userInfo.totalLectures > 0
      ? Math.round((userInfo.completedLectures / userInfo.totalLectures) * 100)
      : 65;

  return (
    <div className="container mt-5" style={{ direction: 'rtl' }}>
      <h2 className="mb-4">👤 الملف الشخصي</h2>
      {userInfo ? (
        <div className="card p-4 shadow-sm border border-light-subtle">
          <p><strong>الاسم:</strong> {userInfo.name || 'غير متوفر'}</p>
          <p><strong>البريد الإلكتروني:</strong> {userInfo.email}</p>
          <p><strong>رقم واتساب:</strong> {userInfo.phone || 'غير متوفر'}</p>
          <p><strong>UID:</strong> {userInfo.uid}</p>

          <hr />

          <p><strong>نسبة الحضور:</strong> {userInfo.attendance || 0}%</p>
          <p><strong>عدد الإنذارات:</strong> {userInfo.warnings || 0}</p>
          <p><strong>المحاضرات المكتملة:</strong> {userInfo.completedLectures || 20} من {userInfo.totalLectures || 20}</p>

          <div className="my-3">
            <strong>التقدم في الكورس:</strong>
            <div className="progress active striped mt-1" style={{ height: '20px' }}>
              <div
                className="progress-bar bg-success stiped active"
                role="progressbar"
                style={{ width: `${Math.min(progress, 100)}%` }}
              >
                {Math.min(progress, 100)}%
              </div>
            </div>
          </div>

          <hr />

          <h5 className="mt-4">📅 جدول المحاضرات القادمة:</h5>
          <ul>
            {lectures.length === 0 ? (
              <li>لا توجد محاضرات حالياً</li>
            ) : (
              lectures.map((lec, index) => (
                <li key={index}>{lec.day}: {lec.title} - الساعة {lec.time}</li>
              ))
            )}
          </ul>

          {quizStats.total > 0 && (
            <>
              <hr />
              <h5>🧠 أداء الطالب في الاختبارات:</h5>
              <p>
                ✅ تم حل {quizStats.score} من {quizStats.total} سؤال بنجاح (
                {Math.round((quizStats.score / quizStats.total) * 100)}%)
              </p>
            </>
          )}

          <hr />

       
          <p><strong>ملاحظات المعلم:</strong> {userInfo.notes || 'لا توجد ملاحظات حالياً'}</p>
        </div>
      ) : (
        <p>جاري تحميل بياناتك...</p>
      )}
    </div>
  );
}

export default Profile;
